import React from 'react';
import {
  Text, View, StyleSheet,
} from '@react-pdf/renderer';
import Space from './space';


const styles = StyleSheet.create({

  space: {
    paddingTop: 20,
  },

  subtitles: {
    fontFamily: 'MuliRegular',
    fontSize: 16,
  },
  textArea: {
    height: 140,
  },

  blueTransparentField: {
    padding: 5,
    backgroundColor: '#eeeeee',
    marginTop: 2,
    marginBottom: 2,
    fontFamily: 'MuliRegular',
    fontSize: 12,
  },
  bold: {
    fontFamily: 'MuliBold',
  },
});
const FormDetailsPDF = ({
  data = [],
}) => (
    <>
      <Text style={styles.subtitles}>Your details</Text>
      <Space />
      <View>
        <Text style={styles.blueTransparentField}>
          <Text style={styles.bold}>FullName: </Text>
          {data[0] || ''}
        </Text>
        <Text style={styles.blueTransparentField}>
          <Text style={styles.bold}>CPCS Registration No.: </Text>
          {data[1] || ''}
        </Text>
      </View>
      <View>
        <Space />
        <Text style={styles.subtitles}>Any special requirements</Text>
        <Space />
        <View>
          <Text style={[styles.blueTransparentField, styles.textArea]}>
            <Text style={styles.bold}>Additional Information: </Text>
            {data[2] || ''}
          </Text>
        </View>
      </View>
    </>
  );

export default FormDetailsPDF;
